import { render, staticRenderFns } from "./previewFormbuilderTemplate.vue?vue&type=template&id=98913526&scoped=true"
import script from "./previewFormbuilderTemplate.vue?vue&type=script&lang=js"
export * from "./previewFormbuilderTemplate.vue?vue&type=script&lang=js"
import style0 from "./previewFormbuilderTemplate.vue?vue&type=style&index=0&id=98913526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98913526",
  null
  
)

export default component.exports